import React, {useEffect, useState} from 'react';
import Dialog from "@mui/material/Dialog";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";
import {useTranslation} from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import {connect} from 'react-redux'
import Typography from "@mui/material/Typography";
import Alert from '@mui/material/Alert';
import { useHistory } from '../../../../utils/reactRouterCompatibility';
import {getSiteEventEditRoute} from "../../../../../router/routes/site/factory/planner";
import Button from "../../../inputs/Button";
import {markAsUsed} from "../../../../../store/actions/planner/ReserveAction";

const TerminateLiveDialog = ({event, open, setOpen, marking, markAsUsed}) => {
    const {t} = useTranslation();
    const history = useHistory();

    const [checked, setChecked] = useState({});

    useEffect(() => {
        setChecked(JSON.parse(localStorage.getItem('live-' + event.Planner_Event__) ?? '{}'));
    }, [open, event]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleTerminate = (e) => {
        e.preventDefault();
        markAsUsed(event.Planner_Event__, Object.keys(checked))
            .then(d => {
                localStorage.removeItem('live-' + event.Planner_Event__);
                history.push(getSiteEventEditRoute(event.Planner_Event__))
            })

    };

    return (
        <Dialog
            open={open}
            aria-labelledby={t('terminate_live')}
            aria-describedby={t('terminate_live')}
        >
            <DialogTitle id="terminate-live-title">{t('terminate_live')}</DialogTitle>
            <DialogContent>
                <Alert severity='info'>
                    {t('reserve_validate_pending', {count: Object.keys(checked).length})}
                </Alert>
                <br/>
                <DialogContentText id="terminate-live-desc">
                    {t('terminate_live_desc')}
                    <br/>
                    <Typography variant="body1" color="textPrimary" component="span">{t('are_you_sure')}</Typography>
                </DialogContentText>


            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={marking}>
                    {t('close_btn')}
                </Button>
                <Button color="primary" type='submit' variant='contained' onClick={handleTerminate}
                        disabled={marking}
                        loading={marking}>
                    {t('live_terminate_btn')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        marking: state.reserve.markingAsUsed,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        markAsUsed: (eventId, reserveIds) => dispatch(markAsUsed(eventId, reserveIds))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TerminateLiveDialog);